module.exports = __webpack_public_path__ + "img/bot3.2f165160.svg";